import React, { useEffect, useState } from "react";

import Table from "../../styled-components/table/table";
import { useHistory } from "react-router-dom";
import * as Style from "./styles/tax-and-inflation";
import { defaultStyles } from "../../../constants/style-constants/utils";
import { Text } from "../../styled-components/text";
import "./styles/tax-inflation-style.css";
import { EditOutlined } from "@ant-design/icons";
import TAX_AND_INFLATION_API from "../../../apis/tax_and_inflation.api";
import moment from "moment";
import NewLoader from "../../styled-components/loader/NewLoader";
import ModalVideo from "../../../newComponents/ModuleVideos/ModalVideo";
function TaxAndInflation() {
  const history = useHistory();
  const { styles } = defaultStyles;
  const [taxCreditList, setTaxCreditList] = useState([]);
  const [taxInfo,setTaxInfo]= useState(null);
  const [loading, setLoading] = useState(false);
  const [carryForwardDate,setCarryForwardDate]= useState(null);
  const [carryForwardData,setCarryForwardData]= useState(null);

  const getTaxCredit = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxCreditList();
      if (data && data.data) {
        let formattedData = data.data.rows.map((row) => {
          return {
            taxCredit: row.taxCredit,
            amountCredit: "$"+(row.amountOfCredit ? row.amountOfCredit : "0"),
            whoseCredit: row.appliesTo,
          };
        });
        setTaxCreditList(formattedData);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getTaxInflationDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        //inflation details
        console.log("response==>", data.data);
        if(data.data[0]){
          setTaxInfo(data.data[0])
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };
  const getLatestPurchaseDate = (rows) => {
    const latestRecord = rows && rows.length > 0 && rows.reduce((latest, current) => {
      const latestDate = new Date(latest.purchaseDate);
      const currentDate = new Date(current.purchaseDate);
      return currentDate > latestDate ? current : latest;
    });
  
    return latestRecord.purchaseDate;
  };
  const getCarryForward = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchCarryForward();
      if (data && data.data && data.data.rows) {
        const latestPurchaseDate = getLatestPurchaseDate(data.data.rows);
        console.log("Latest Purchase Date: ", latestPurchaseDate);
        setCarryForwardDate(latestPurchaseDate);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getCarryForwardTax = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchCarryForwardTax();
      if (data && data.data && data.data.rows) {
        // Fetch Long Term and Short Term separately
        const longTermData = data.data.rows.filter(item => item.term === "Long Term");
        const shortTermData = data.data.rows.filter(item => item.term === "Short Term");
  
        // Sort by 'year' to get the latest entry (assuming 'year' is in a sortable format)
        const latestLongTerm = longTermData.sort((a, b) => new Date(b.year) - new Date(a.year))[0];
        const latestShortTerm = shortTermData.sort((a, b) => new Date(b.year) - new Date(a.year))[0];
  
        // Get the remaining amounts from the most recent entries
        const longTermRemainingAmount = latestLongTerm ? latestLongTerm.amountRemain : null;
        const shortTermRemainingAmount = latestShortTerm ? latestShortTerm.amountRemain : null;
  
        // You can now use longTermRemainingAmount and shortTermRemainingAmount as needed
        console.log("Long Term Remaining Amount: ", longTermRemainingAmount);
        console.log("Short Term Remaining Amount: ", shortTermRemainingAmount);
        const obj= {
          shortTermData:shortTermRemainingAmount,
          longTermData:longTermRemainingAmount,
        }
        setCarryForwardData(obj);

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getAll=async()=>{
    await getTaxInflationDetails();
    await getTaxCredit()
    await getCarryForward();
    await getCarryForwardTax();
  }
  useEffect(() => {
    getAll();
  }, []);

  // useEffect(() => {
  //   getTaxInflationDetails();
  //   getTaxCredit();
  // }, []);

  const tableColumnsData = [
    { id: "1", name: "Tax Credit", class: { width: "10rem" } },
    { id: "2", name: "Amount Of Credit", class: { width: "10rem" } },
    { id: "3", name: "Whose Credit", class: { width: "10rem" } },
  ];

  const taxInfoObj = {
    "State Taxation": taxInfo && taxInfo.state ? taxInfo.state : "",
    "Tax Filing Election": taxInfo && taxInfo.taxFillingElection ? taxInfo.taxFillingElection : "",
    Deductions: taxInfo && taxInfo.deductions ? taxInfo.deductions : "",
    "State Tax Effective Rate": taxInfo && taxInfo.stateTaxRate ? taxInfo.stateTaxRate +"%" : "",
    "Federal Tax Rate":taxInfo && taxInfo.federalTaxRate ? taxInfo.federalTaxRate +"%" : "",
    "Total Tax Rate": taxInfo && taxInfo.totalTaxRate ? taxInfo.totalTaxRate +"%": "",
    "Federal Collectible Tax Rate": taxInfo && taxInfo.federalCollectibleTaxRate ? taxInfo.federalCollectibleTaxRate +"%": "",
  };

  const taxCreditObj = {
    "Tax Credit": "Adoption Credit",
    "Amount Of Credit": "80",
    "Whose Credit": "Child",
  };

  const capitalGainObj = {
    "Subject to Cap Gains": taxInfo && taxInfo.amountWithdrawnCapGains ? taxInfo.amountWithdrawnCapGains +"%" : "",
    "Capital Gains Rate - Long Term": taxInfo && taxInfo.capGainsRateFederal ? taxInfo.capGainsRateFederal +"%" : "",
    "Capital Gains Rate - Short Term": taxInfo && taxInfo.capGainsRateState ? taxInfo.capGainsRateState +"%" : "",
    "Gains Rate Federal Short Term": taxInfo && taxInfo.capGainsRateFederalShortTerm ? taxInfo.capGainsRateFederalShortTerm +"%" : "",
    "Gains Rate State Short Term": taxInfo && taxInfo.capGainsRateStateShortTerm ? taxInfo.capGainsRateStateShortTerm +"%" : "",
  };

  const carryForwardObj = {
    "Long Term Carry Forward": carryForwardData && carryForwardData.shortTermData && "$" + parseFloat(carryForwardData.shortTermData).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    "Short Term Carry Forward": carryForwardData && carryForwardData.longTermData && "$" + parseFloat(carryForwardData.longTermData).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    "Carry Forward Updated": carryForwardDate && moment(carryForwardDate).format("MMM DD, YYYY"),
  };

  const inflationRateObj = {
    "General Inflation Rate": taxInfo && taxInfo.generalInflationRate ? taxInfo.generalInflationRate +"%" : "",
    "Medical Inflation Rate": taxInfo && taxInfo.medicalInflationRate ? taxInfo.medicalInflationRate +"%" : "",
    "Education Inflation Rate": taxInfo && taxInfo.educationInflationRate ? taxInfo.educationInflationRate +"%" : "",
    "Luxury Inflation Rate": taxInfo && taxInfo.luxuryInflationRate ? taxInfo.luxuryInflationRate +"%" : "",
    "Housing Inflation Rate": taxInfo && taxInfo.housingInflationRate ? taxInfo.housingInflationRate +"%" : "",
  };

  const allData = [
    { title: "Tax Information", data: taxInfoObj },
    { title: "Capital Gains", data: capitalGainObj },
    { title: "Carry Forward", data: carryForwardObj },
  { title: "Inflation Rates", data: inflationRateObj },
  ];

  return (
    <div>
      <div className="tax-inflation-header-container">
        <h3>Tax and inflation </h3>
        <button onClick={() => history.push("/tax_inflation_edit/1")}>
          <EditOutlined />
          <p>Edit</p>
        </button>
      </div>
      <ModalVideo module="Tax & Inflation" autoOpen={true} />
      <div
        style={{
          display: "",
          padding: "16px",
          margin: "1rem",
          backgroundColor: "#ffffff",
          borderRadius: "10px",
           position:"relative"
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            gap: "1rem",
            alignItems: "start",
           
          }}
        >
          {allData &&
            allData.map((data, index) => (
              <div
                className="tax-inflation-cards-container"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  width: "100%",
                }}
              >
                <Style.TableHeader>{data.title}</Style.TableHeader>
                {data &&
                  Object.keys(data.data).map((key, index) => (
                    <Style.TableBodyRow
                      key={index}
                      backgroundColor={
                        (index + 1) % 2 === 0 ? "white" : "#EBF1FF"
                      }
                      style={{paddingInline:"4px",display: "flex",flexWrap: "wrap"}}
                    >
                      <Text
                        style={{
                          ...styles.text.labelBoldText, // Spread the styles object
                          textWrap: "nowrap", // Add the additional style
                        }}
                        width="12rem"
                        color="rgba(0,0,0,.65)"
                      >
                        {key}{" "}
                      </Text>

                      <Text width={key ==="Carry Forward Updated" || key === "Tax Filing Election" ? "" :"5rem"} color="rgba(0,0,0,.65)">
                        {data.data[key]}
                      </Text>
                    </Style.TableBodyRow>
                  ))}
              </div>
            ))}
        </div>
        <NewLoader isLoading={loading} />
      </div>

      <div
        style={{
          margin: "2rem 1rem",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          position:"relative"
        }}
      >
        <Table
          tableColumnsData={tableColumnsData}
          tableBodyData={
            taxCreditList && taxCreditList.length > 0 && taxCreditList
          }
        />
        {taxCreditList && taxCreditList.length === 0 &&
          <div className="noDataToShow" style={{margin:"1rem auto",textAlign:"center"}}>No Data To Show</div>
          }
          <NewLoader isLoading={loading} />
      </div>
    </div>
  );
}

export default TaxAndInflation;
